<template>
  <div class="home" :class="[$store.state.collapse || $store.state.activeModal ? 'overflow-y-hidden overflow-x-hidden': '']">
    <div class="wrapper w-full">
      <div class="block lg:hidden">
        <MobileNav/>
      </div>
      <div class="hidden lg:block w-full border-solid bgrd">
        <TheSidebar/>
      </div>
      <div class="w-full page relative overflow-x-hidden" :class="[$store.state.collapse == true ? 'ml-16' : 'ml-0']">
        <div class="p-3 pb-32">
          <main class="rounded-md bg-white">
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition> 
          </main>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TheSidebar from '@/components/TheSidebar.vue'
import MobileNav from '@/components/MobileNav.vue'

export default {
  components:{
    TheSidebar, MobileNav
  }

}
</script>
<style scoped>
.home{
  height: 100%
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
@media only screen and (min-width: 1024px){
  div.bgrd{
    background-color: #00A859;
    z-index: 1000;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    position: sticky;
    top: 0;
    height: 100vh;
    box-sizing: border-box;
    
  }
  .wrapper{
    display: grid;
    grid-template-columns: 100px auto;
    grid-template-rows: auto;
    min-height: 100vh;
    width: 100%;
  }
  div.page{
    transition: margin 0.5s;
  }
}
</style>